// extracted by mini-css-extract-plugin
export default {"section":"a0Jh40AcbB","sectionTitle":"RzAyP3Uy2K"};